import { CheckListTaskEntity } from 'backend-entity';

export type CrmGetCheckListTaskResponseDto = CheckListTaskEntity;
